import * as React from 'react'
import classNames from 'classnames'

import { BABYLIST_EXTENSION_URL } from 'shared/constants'
import { InfoButton } from 'components/buttons'
import Image from 'components/image'
import css from './install-extension-button.scss'

interface InstallExtensionButtonProps {
  className?: string
  showChromeLogo?: boolean
  buttonText?: string
}

export const InstallExtensionButton: React.FC<InstallExtensionButtonProps> = ({
  className,
  showChromeLogo = true,
  buttonText = 'Get the Babylist Button',
}) => {
  const handleOnClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()
    document.cookie = `browser_extension_referer=${window.location.origin}/registry/new/try-it-out;path=/`
    window.open(BABYLIST_EXTENSION_URL)
  }

  return (
    <InfoButton
      pill
      className={classNames(css.Button, className)}
      target="_blank"
      onClick={handleOnClick}
    >
      {showChromeLogo && (
        <Image
          alt="chrome logo"
          className={css.BrowserIcon}
          src="https://res.cloudinary.com/babylist/image/upload/w_40/v1664907822/Browser%20Extension%20Resources/chrome-logo.png"
          width={40}
        />
      )}
      {buttonText}
    </InfoButton>
  )
}

export default InstallExtensionButton
